<template>
  <div class="page-profile-edit pr-10" style="overflow-x: hidden;">
    <div class="extension-details" v-if="user">

      <div class="flex justify-space-between" v-if="$route.path === '/salesforce' && tasksSetting === 'User'">
        <span class="mr-5 mb-10">Task generation</span>
        <el-switch
          :value="sfTasks"
          @change="toggleSfTasks"
          active-color="#ff8f02"
        />
      </div>

      <div class="flex justify-space-between">
        <span class="mr-5">Do not disturb</span>
        <el-switch
          :value="userDND"
          @change="toggleUserDND"
          active-color="#ff8f02"
        />
      </div>
      <hr />

      <div>
        <el-checkbox @input="onCheckbox" v-model="forwardForm.enableForward">
          Enable forwarding
        </el-checkbox>
        <el-tag
          v-if="forwardingNumber && forwardForm.enableForward"
          type="info"
        >
          Currently Forwarding To: {{ numberFormatter(forwardingNumber) }} {{ forwardingEntity ? `(${forwardingEntity})` : ''}}
        </el-tag>
      </div>

      <el-row :gutter="20">
        <el-col :span="5">

        </el-col>
        <el-col :span="14" >
        </el-col>
      </el-row>
      <div v-if="forwardForm.enableForward">
        <h4 class="mb-0 mt-5">Update Forwarding</h4>
        <div class="form-modal flex align-center">
          <div class="el-input el-input--prefix">
            <input
              v-model="forwardForm.forwardingNumber"
              type="text"
              autocomplete="off"
              placeholder="Enter number"
              class="el-input__inner"
              v-mask="'(###) ###-####'"
            />
            <span class="el-input__prefix">Number</span>
          </div>
          <el-button
            type="primary"
            @click="updateForwarding"
            style="margin-left: 5px; height: 50px;"
          >
            Save
          </el-button>
        </div>
      </div>
      <hr />

    <div class="form-modal flex">
      <div style="width: 100%;">
        <dads-select
          v-model="timezone"
          placeholder="Select time zone"
          @change="updateTimezone"
          filterable
          style="margin-right: 0; margin-left: 0;"
        >
          <template slot="prefix">
            Time zone
          </template>
          <el-option
            v-for="(item, index) in timezoneOptions"
            :key="index"
            :label="item.name"
            :value="item.name"
          />
        </dads-select>
      </div>
    </div>
    <hr />

      <div class="flex justify-space-between">
        <div>
          <span class="mr-5">Incoming calls</span>
          <el-popover trigger="hover" width="300px" placement="bottom-start">
            <i class="more-info-icon el-icon-question" slot="reference" />
            <span class="black-text">
                Enables notifications for calls
              </span>
          </el-popover>
        </div>

        <el-switch
          :value="enableCallNotifications"
          @change="toggleEnableCallNotifications"
          active-color="#35be8b"
          inactive-color="#f25a6b"
        />
      </div>

      <div class="form-modal ringtone-settings pb-20">
        <div class="mt-10">
          <div>
            <el-select
              v-model="incomingRingTone"
              placeholder="Select incoming ring tone"
              style="margin-right: 0; margin-left: 0;"
            >
              <template slot="prefix">
                Incoming ring tone
              </template>
              <el-option
                v-for="item in allRingToneOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <audio id="incomingRingToneAudio">
              <source
                src="https://global-app.s3.amazonaws.com/omnia-assets/ringtones/10.mp3"
                type="audio/mpeg"
              />
            </audio>
          </div>
        </div>
        <hr />

        <div class="flex">
          <span class="mr-10">Incoming ring</span>
          <el-slider
            v-model="inboundRingVolume"
            class="preferences-slider"
          />
        </div>
        <div class="flex">
          <span class="mr-10">Outbound ring</span>
          <el-slider
            v-model="outboundRingVolume"
            class="preferences-slider"
          />
        </div>
        <div class="flex">
          <span class="mr-10">Call waiting notify</span>
          <el-slider
            v-model="callWaitingVolume"
            class="preferences-slider"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import feathersClient from "@/feathers/feathers-client";
import DadsSelect from "@/components/select";
import moment from "moment-timezone";
import {phoneNumberFormatter} from "@/globals/globals";

export default {
  name: "ProfileEdit",
  components: {
    DadsSelect
  },
  props: {
    tasksSetting: {required: true, default: ''}
  },
  data() {
    return {
      forwardingNumber: "",
      forwardingEntity: "",
      forwardForm: {
        command: "forwardExtension",
        extId: null,
        enableForward: false,
        tenantId: null,
        forwardingNumber: ""
      },
      enableCallNotifications: false,
      sfTasks: false,
      timezone: null,
      timezoneOptions: [],
      incomingRingToneOptions: [
        {
          value:
            "https://global-app.s3.amazonaws.com/omnia-assets/ringtones/10.mp3",
          label: "Tranquility"
        },
        {
          value:
            "https://global-app.s3.amazonaws.com/omnia-assets/ringtones/2.mp3",
          label: "Buzz"
        },
        {
          value:
            "https://global-app.s3.amazonaws.com/omnia-assets/ringtones/3.mp3",
          label: "Skipe"
        },
        {
          value:
            "https://global-app.s3.amazonaws.com/omnia-assets/ringtones/4.mp3",
          label: "Chimes"
        },
        {
          value:
            "https://global-app.s3.amazonaws.com/omnia-assets/ringtones/5.mp3",
          label: "Submerged"
        },
        {
          value:
            "https://global-app.s3.amazonaws.com/omnia-assets/ringtones/6.mp3",
          label: "Woody"
        },
        {
          value:
            "https://global-app.s3.amazonaws.com/omnia-assets/ringtones/7.mp3",
          label: "Hopscotch"
        },
        {
          value:
            "https://global-app.s3.amazonaws.com/omnia-assets/ringtones/8.mp3",
          label: "Interstellar"
        },
        {
          value:
            "https://global-app.s3.amazonaws.com/omnia-assets/ringtones/9.mp3",
          label: "Agency"
        },
        {
          value:
            "https://global-app.s3.amazonaws.com/omnia-assets/ringtones/1.mp3",
          label: "Hotel"
        }
      ],
      superAdminIncomingRingToneOptions: [
        {
          value:
            "https://global-app.s3.amazonaws.com/omnia-assets/ringtones/Lorna.mp3",
          label: "Lorna Shore!"
        }
      ]
    };
  },

  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    userDirectDials() {
      if (this.user) {
        return this.user.myExtension ? this.user.myExtension.directDials : [];
      }
    },
    allRingToneOptions () {
      return this.isSuperAdmin ? [...this.incomingRingToneOptions, ...this.superAdminIncomingRingToneOptions] : this.incomingRingToneOptions;
    },
    incomingRingTone: {
      get: function() {
        return this.$store.state.incomingRingTone;
      },
      set: function(val) {
        this.$store.commit("setIncomingRingTone", val);
        let incomingRingToneAudio = document.getElementById(
          "incomingRingToneAudio"
        );
        incomingRingToneAudio.src = val;
        incomingRingToneAudio.volume = this.inboundRingVolume / 100;
        incomingRingToneAudio.play();
      }
    },
    inboundRingVolume: {
      get: function() {
        return this.$store.state.inboundRingVolume * 100;
      },
      set: function(val) {
        this.$store.commit("setInboundRingVolume", val);
      }
    },
    outboundRingVolume: {
      get: function() {
        return Math.round(this.$store.state.outboundRingVolume * 100);
      },
      set: function(val) {
        this.$store.commit("setOutboundRingVolume", val);
      }
    },
    callWaitingVolume: {
      get: function() {
        return Math.round(this.$store.state.callWaitingVolume * 100);
      },
      set: function(val) {
        this.$store.commit("setCallWaitingVolume", val);
      }
    },
    isSuperAdmin() {
      if (this.user) {
        return +this.user.userRole === 1;
      }
    },
    userDND() {
      return this.$store.state.userDND;
    }
  },

  methods: {
    ...mapActions("user-settings", {
      createUserSettings: "create"
    }),

    numberFormatter(val) {
      return val ? phoneNumberFormatter(val) : val;
    },

    onCheckbox(checked) {
      if (!checked) {
        this.createUserSettings({
          command: "forwardExtension",
          extId: this.forwardForm.extId,
          enableForward: false
        }).then(res => {
          this.forwardingNumber = ""
          this.forwardingEntity = ""
          this.$notify.success({
            title: 'Forwarding Disabled',
            message: 'Extension forwarding successfully disabled'
          });
        });
      }
    },

    updateForwarding() {
      const { forwardingNumber } = this.forwardForm;
      const body = { ...this.forwardForm };

      // ⭐️ Check for valid forwarding number ⭐️ //
      if (!forwardingNumber || forwardingNumber.includes("_")) {
        this.$notify.error({
          title: "Invalid forwarding number.",
          message: "The forwarding number must contain 10 digits."
        });
        return;
      }

      body.forwardingNumber = forwardingNumber.replace(/\(|\)|-/g, "");

      this.createUserSettings(body)
        .then(() => {
          this.forwardingNumber = body.forwardingNumber;
          this.forwardingEntity = '';
          this.forwardForm.forwardingNumber = '';
          this.$notify.success({
            title: "Forwarding enabled",
            message: "Extension forwarding successfully enabled."
          });
        })
        .catch(error => {
          if (error.hasOwnProperty("errors")) {
            this.$notify({
              title: error.message,
              message: error.errors[Object.keys(error.errors)[0]],
              type: "error"
            });
          } else {
            this.$notify({
              title: error.name,
              message: error.message,
              type: "error"
            });
          }
        });
    },

    async toggleEnableCallNotifications() {
      // console.log('toggle enable call');

      //make sure we have the latest copy of the user before updating
      const currentUser = await feathersClient.service('users').get(this.user.id);
      this.$store.commit('auth/setUser', currentUser);

      this.enableCallNotifications = !this.enableCallNotifications;
      const {
        email,
        receiveQueueReports,
        receiveQueueUserReports,
        tenantId,
        userRole,
        tenantIds,
        adminQueues,
        timezone,
        partnerId
      } = this.user;
      feathersClient
        .service("users")
        .patch(this.user.id, {
          email,
          extension: this.user.myExtension.number,
          receiveQueueReports,
          receiveQueueUserReports,
          resetPassword: false,
          tenantId,
          tenantIds,
          adminQueues,
          userRole,
          enableCallNotifications: this.enableCallNotifications,
          timezone: this.timezone,
          partnerId
        })
        .then(() => {
          let currentUser = { ...this.user };
          currentUser.enableCallNotifications = this.enableCallNotifications
            ? 1
            : 0;
          this.$store.commit("auth/setUser", currentUser);
        });
    },
    async updateTimezone() {

      //make sure we have the latest copy of the user before updating
      const currentUser = await feathersClient.service('users').get(this.user.id);
      this.$store.commit('auth/setUser', currentUser);

      if (this.user.timezone !== this.timezone) {
        // console.log('update the time zone');
        const {
          email,
          receiveQueueReports,
          receiveQueueUserReports,
          tenantId,
          userRole,
          tenantIds,
          adminQueues,
          partnerId
        } = this.user;
        feathersClient
          .service("users")
          .patch(this.user.id, {
            email,
            extension: this.user.myExtension.number,
            receiveQueueReports,
            receiveQueueUserReports,
            resetPassword: false,
            tenantId,
            tenantIds,
            adminQueues,
            userRole,
            timezone: this.timezone,
            partnerId
          })
          .then(() => {
            let currentUser = { ...this.user };
            currentUser.timezone = this.timezone;
            this.$store.commit("auth/setUser", currentUser);
            const offsetUTCServer = moment.tz("America/Chicago").utcOffset();
            const offsetMe = moment.tz(this.timezone).utcOffset();
            const userOffset = offsetMe - offsetUTCServer;
            this.$store.commit("setUserTimeOffset", userOffset);
          });
      }
    },
    toggleUserDND(val) {
      this.$store.commit("setUserDND", val);
      //send the action to ami, userevent ami. this should result in an event firing the assures the store is accurate.
      const dndStatus = val === true ? "on" : "";
      const { peerName } = this.user.myExtension;
      feathersClient.service("nats-actions-handler").create({
        reqType: "setDND",
        peerName,
        dndStatus,
        hostServer: this.userHostServer,
        extensionId: this.user.myExtension.id
      });
    },
    async toggleSfTasks(){
      console.log('toggling sf tasks');

      //make sure we have the latest copy of the user before updating
      const currentUser = await feathersClient.service('users').get(this.user.id);
      this.$store.commit('auth/setUser', currentUser);


      this.sfTasks = !this.sfTasks;
      const {
          email,
          receiveQueueReports,
          receiveQueueUserReports,
          tenantId,
          userRole,
          tenantIds,
          adminQueues,
          partnerId,
          sfTasks
        } = this.user;
        feathersClient
        .service("users")
        .patch(this.user.id,{
          email,
          extension: this.user.myExtension.number,
          receiveQueueReports,
          receiveQueueUserReports,
          resetPassword: false,
          tenantId,
          tenantIds,
          adminQueues,
          userRole,
          enableCallNotifications: this.enableCallNotifications,
          timezone: this.timezone,
          partnerId,
          sfTasks: this.sfTasks
        })
        .then(() => {
          let currentUser = {...this.user};
          currentUser.sfTasks = this.sfTasks ? 1 : 0;
          this.$store.commit("auth/setUser", currentUser);
        });
    },
    queryTimezones() {
      feathersClient
        .service("timezones")
        .find({
          query: {
            $sort: { name: 1 }
          }
        })
        .then(res => (this.timezoneOptions = res));
    }
  },

  async created() {
    if (this.user && this.user.myExtension) {
      const { id, tenantId, unconditionalStatus } = this.user.myExtension;

      this.forwardForm.extId = id;
      this.forwardForm.tenantId = tenantId;

      // ⭐️ Check if forwarding is enabled ⭐️ //
      const extension = await feathersClient.service("extensions").get(id);

      if (!extension.unconditionalStatus) {
        return;
      }

      // ⭐️ Grab forwarding destination if any ⭐️ //
      const {forwardingDestination} = extension;
      if(!forwardingDestination){
        return;
      }

      this.forwardingNumber = forwardingDestination.name;
      this.forwardingEntity = forwardingDestination.entity;
      this.forwardForm.enableForward = true;

    }
  },
  mounted() {
    if(this.user){
      this.enableCallNotifications = this.user.enableCallNotifications === 1;
      this.sfTasks = this.user.sfTasks === 1;
      this.timezone = this.user.timezone;
      this.queryTimezones();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../assets/scss/variables";

.el-checkbox {
  width: 200px;
  margin-left: 0;
}

.page-profile-edit {
  margin-top: 20px;
  max-height: 300px;
  overflow-x: hidden;
  overflow-y: auto;
}

.ringtone-settings{
  font-size: 11pt;
}
</style>
